import React from "react";
import Bubbles from "../bubbles/bubbles";
import "./HomePage.css";

export default function HomePage() {
  return (
    <div className="home-page">
      <Bubbles />
    </div>
  );
}
